import React from "react";
import EditTaskItem from "../components/EditTask/EditTaskItem";

export default function EditTask() {
  return (
    <div className="container relative">
      <EditTaskItem />
    </div>
  );
}
